import { FieldDefinition } from "../form-builder/field-definition.model";
import { FormField } from "../form-builder/form-field.model";
import { GridConfig } from "../grid/grid-config.model";
import { FieldDefinitionService } from "../../services/field-definition.service";

// Represents the properties of a column available to a Home Page Grid
// Gets serialized to JSON as part of a Home Page Grid FormField's FormTemplateInstancesGridJsonConfig field
export class FormTemplatePropertyInfo {
    public static readonly METADATA: string = 'metadata';
    public static readonly FORM_LEVEL_FIELD: string = 'field';
    public static readonly GRID_FIELD: string = 'grid';
    public static readonly CHILD_FIELD_OF_GRID: string = 'child-of-grid';
    public static readonly FIELD_WITH_ONLY_VIRTUAL_FIELDS = 'hide';

    public fieldId: number;
    public propertyName: string;
    public alias: string;
    public columnWidth: number;
    public isSelected: boolean;
    public isGridData: boolean;
    public children: FormTemplatePropertyInfo[]; // grid column fields
    public type: string;

    // Filter-related properties.
    public defaultFilterOperator: string; // 'contains' for text fields and 'eq' otherwise.
    public optionalFilterValue: string;
    public optionalAggregateNames: string;
    public associatedFlexFieldName: string;

    // Too many params -- look to reduce them or combine into a param object
    public constructor(
        propertyName: string,
        type: string,
        isGridData: boolean = false,
        field: FormField = null,
        fieldDefinitionService: FieldDefinitionService = null,
        alias: string = null,
        columnWidth: number = 0,
        isSelected: boolean = false
    ) {
        this.propertyName = propertyName;
        this.alias = alias;
        this.columnWidth = columnWidth;
        this.isSelected = isSelected;
        this.isGridData = isGridData;
        this.type = type;
        this.fieldId = (field != null) ? field.id : 0;

        if (field) {
            if (field.childFormFields?.length > 0) {
                this.children = [];
                let childAndVirtual = GridConfig.getChildAndAnyVirtualFormFields(field, fieldDefinitionService, 0);
                let lastFieldId = -1;
                for (let child of childAndVirtual) {
                    // If a field has id of zero it's a virtual field
                    // this code set the id to that of the first "real" grid cascading dropdown field
                    if (child.id > 0) lastFieldId = child.id;
                    else if (child.id == 0) child.id = lastFieldId; 
                    let name = child.displayName || child.name;
                    this.children.push(new FormTemplatePropertyInfo(name, FormTemplatePropertyInfo.CHILD_FIELD_OF_GRID, false, child));
                }
            }
        }
    }

    public setDefaultFilterOperator(defaultFilterOperator: string): FormTemplatePropertyInfo {
        this.defaultFilterOperator = defaultFilterOperator;
        return this;
    }
}
